import { Plugin } from 'ckeditor5';

import GlossaryEditing from './glossaryediting.js';
import GlossaryUI from './glossaryui.js';

export default class GlossaryTerms extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [
			GlossaryEditing,
			GlossaryUI
		];
	}

	static get pluginName() {
		return 'GlossaryTerms';
	}

}
